/**
 * @name git-config.ts
 * @version 1.0.0
 * @description Configuración de variables de git generada automáticamente
 * @author
 * @changelog
 * 1.0.0 - 2024/12/19 - @santiago - Configuración inicial
 * 1.1.0 - 2024/12/19 - @mrcalamitus - Refactorizado para usar GitUtils
 * 1.2.0 - 2024/12/19 - @mrcalamitus - Eliminada redundancia de interfaces
 */

/**
 * Variables de git capturadas durante el build
 */
export const GIT_CONFIG = {
  "GIT_HASH": "4b37c3e643b68841cdf3abe6611eb24779807a9c",
  "GIT_SHORT_HASH": "4b37c3e6",
  "GIT_BRANCH": "master",
  "GIT_VERSION": "git version 2.55.0",
  "GIT_LAST_COMMIT_DATE": "Tue, 27 Oct 2026 00:57:42 GMT",
  "GIT_CHANGED_FILES": "",
  "LAST_DEPLOY_DATE": "Tue, 27 Oct 2026 00:59:58 GMT",
  "LAST_TAG": "2.2.1"
} as const;

/**
 * Interfaz para las variables de git
 */
export interface IGitConfig {
    GIT_HASH: string;
    GIT_SHORT_HASH: string;
    GIT_BRANCH: string;
    GIT_VERSION: string;
    GIT_LAST_COMMIT_DATE: string;
    GIT_CHANGED_FILES: string;
    LAST_DEPLOY_DATE: string;
    LAST_TAG: string;
}
